import { render, staticRenderFns } from "./FAQCategories.vue?vue&type=template&id=5c6e064e&scoped=true&"
import script from "./FAQCategories.vue?vue&type=script&lang=ts&"
export * from "./FAQCategories.vue?vue&type=script&lang=ts&"
import style0 from "./FAQCategories.vue?vue&type=style&index=0&id=5c6e064e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e064e",
  null
  
)

export default component.exports